import { render, staticRenderFns } from "./PbSelector.vue?vue&type=template&id=5edc5e92&"
import script from "./PbSelector.vue?vue&type=script&lang=js&"
export * from "./PbSelector.vue?vue&type=script&lang=js&"
import style0 from "./PbSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports